import type { UserRole } from '@/types';

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  CONTENT_MANAGER: 'content_manager',
  SUPPORT: 'support',
  ANALYST: 'analyst',
  PATIENT: 'patient',
} as const;

export const ADMIN_PANEL_ROLES: UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.CONTENT_MANAGER,
  USER_ROLES.SUPPORT,
  USER_ROLES.ANALYST,
];

export const TABLE_PAGE_SIZES = [10, 20, 50, 100] as const;

export const DEFAULT_SORT_FIELD = 'createdAt';
export const DEFAULT_SORT_ORDER = 'DESC' as const;

export const USER_TABLE_COLUMNS = {
  USER: 'user',
  ROLE: 'role',
  PLAN: 'plan',
  STATUS: 'status',
  VERIFICATION: 'verification',
  CREATED_AT: 'createdAt',
  LAST_LOGIN: 'lastLoginAt',
  ACTIONS: 'actions',
} as const;

export const ROLE_COLORS: Record<UserRole, string> = {
  super_admin: 'red',
  content_manager: 'purple',
  support: 'blue',
  analyst: 'cyan',
  patient: 'default',
};

export const IS_ACTIVE_COLORS = {
  true: 'green',
  false: 'red',
} as const;

export const USER_FORM_LABELS = {
  CREATE_TITLE: 'Create Platform User',
  EDIT_TITLE: 'Edit User',
  CREATE_DESCRIPTION: 'Create an admin panel user',
  EDIT_DESCRIPTION: 'Update platform user information and settings',
  BACK_BUTTON: 'Back to Users',
  CANCEL_BUTTON: 'Cancel',
  CREATE_BUTTON: 'Create User',
  UPDATE_BUTTON: 'Update User',
} as const;
